/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

document.addEventListener("DOMContentLoaded", function() {
  var buyNowButton = document.getElementById("BuyNowButton");
  if (buyNowButton) {
    buyNowButton.addEventListener("click", function() {
      window.location.href = "/checkout";
    });
  }
});

/* O tema reescreve o bloco de preço ao trocar de variante e injeta "em até 12x de ..." com ícone de cartão; esconde sempre */
(function () {
  var style = document.createElement('style');
  style.setAttribute('data-hide-installments', '');
  style.textContent = '.price-list p{display:none !important;}';
  document.head.appendChild(style);
})();

/* Rolagem suave e lenta dos botões "subir" da descrição do produto até a área de compra */
(function () {
  var rafId = null;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function easeInOutCubic(t) {
    return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
  }

  function jumpTo(y) {
    try { window.scrollTo({ top: y, left: 0, behavior: 'instant' }); } catch (e) { window.scrollTo(0, y); }
  }

  function cancelScroll() {
    if (rafId) { cancelAnimationFrame(rafId); rafId = null; }
  }

  function smoothScrollTo(targetY) {
    cancelScroll();
    var startY = window.pageYOffset;
    var distance = targetY - startY;
    if (Math.abs(distance) < 4) return;
    if (reduceMotion) { jumpTo(targetY); return; }

    var duration = Math.min(2200, Math.max(1000, Math.abs(distance) * 0.45));
    var startTime = null;

    function step(now) {
      if (startTime === null) startTime = now;
      var progress = Math.min((now - startTime) / duration, 1);
      jumpTo(startY + distance * easeInOutCubic(progress));
      rafId = progress < 1 ? requestAnimationFrame(step) : null;
    }
    rafId = requestAnimationFrame(step);
  }

  function findBuyArea() {
    return document.querySelector('.product-meta') ||
      document.querySelector('.pack-bundle') ||
      document.querySelector('.product-form__variants') ||
      document.querySelector('.product-form');
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('.mdv a[href^="#"]');
    if (!link) return;

    var hash = link.getAttribute('href');
    var target = null;
    if (hash === '#top' || hash === '#') {
      target = findBuyArea();
    } else {
      try { target = document.querySelector(hash); } catch (e) { target = null; }
    }
    if (!target) return;

    event.preventDefault();
    var headerOffset = 90;
    var y = target.getBoundingClientRect().top + window.pageYOffset - headerOffset;
    smoothScrollTo(Math.max(0, y));
  });

  ['wheel', 'touchstart', 'keydown'].forEach(function (name) {
    window.addEventListener(name, cancelScroll, { passive: true });
  });
})();
